module.exports = __webpack_public_path__ + "img/discipline.c3515a54.jpg";